import usePortfolioForDeal from "./usePortfolioForDeal";

export default function usePortfolioNavigation(dealId: number): IPortfolioNavigation {
    const { deals } = usePortfolioForDeal(dealId);
    const index = deals.findIndex(d => d.id === dealId);
    return {
        prevDealId: index > 0 ? deals[index - 1].id : null,
        nextDealId: index >= 0 && index < deals.length - 1 ? deals[index + 1].id : null,
    };
}

interface IPortfolioNavigation {
    prevDealId: number | null;
    nextDealId: number | null;
}
